<div
  class="min-h-screen grid-bg bg-slate-950 relative overflow-hidden flex items-center justify-center p-4 sm:p-6"
>
  <!-- Animated blob backgrounds -->
  <div class="absolute inset-0 opacity-20 pointer-events-none">
    <div
      class="absolute top-20 left-20 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply filter blur-3xl animate-blob"
    ></div>
    <div
      class="absolute top-40 right-20 w-72 h-72 bg-[#0080f3] rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-2000"
    ></div>
    <div
      class="absolute bottom-20 left-1/2 w-72 h-72 bg-[#0ea5e9] rounded-full mix-blend-multiply filter blur-3xl animate-blob animation-delay-4000"
    ></div>
  </div>

  <!-- Back to home button -->
  <a
    routerLink="/"
    class="absolute top-4 sm:top-6 left-4 sm:left-6 z-20 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 backdrop-blur-md border border-white/10 text-slate-400 hover:text-white hover:bg-white/10 hover:border-white/20 transition text-sm"
  >
    <i class="bi bi-arrow-left"></i>
    <span class="hidden sm:inline">Volver al inicio</span>
  </a>

  <!-- Auth card -->
  <div class="relative z-10 w-full max-w-md">

    <!-- Logo / Brand -->
    <div class="text-center mb-8">
      <img
        src="/img/imagotipo-blanco.png"
        alt="VentaClick"
        class="w-36 sm:w-40 mx-auto mb-3"
      />
      <p class="text-slate-400 text-sm">Sistema de gestión</p>
    </div>

    <!-- Subtle radial glow behind card -->
    <div class="absolute inset-0 bg-[#0080f3]/10 blur-3xl rounded-full -z-10"></div>

    <!-- Glass card body with router-outlet -->
    <div
      class="relative bg-linear-to-br from-white/10 to-white/5 backdrop-blur-xl border border-white/10 hover:border-white/20 rounded-2xl shadow-2xl p-6 sm:p-8 transition-colors duration-500"
    >
      <!-- Decorative top accent line -->
      <div class="absolute top-0 left-6 right-6 h-px bg-linear-to-r from-transparent via-[#0080f3]/50 to-transparent"></div>
      <router-outlet />
    </div>

    <!-- Footer -->
    <p class="text-center text-xs text-slate-500 mt-6">
      &copy; {{ currentYear }} Ventaclick. Todos los derechos reservados.
    </p>
  </div>
</div>
